import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import SubmittalService from '@/services/SubmittalService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    data: [],
    totalItems: 0,
    total: 0,
    inProcess: 0,
    confirmed: 0,
    loading: false,
    error: null,
};

export const getSubmittalList = createAsyncThunk(
    'submittals/getSubmittalList',
    async (data, { rejectWithValue }) => {
        try {
            const response = await SubmittalService.getSubmittalList(data);
            return response.data;
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const submittalListSlice = createSlice({
    name: 'submittalList',
    initialState: model,
    reducers: {},
    extraReducers: (builder) => {
        // submittal list
        builder.addCase(getSubmittalList.pending, (state) => {
            state.loading = true;
        }).addCase(getSubmittalList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload.submittals;
            state.totalItems = action.payload.total_of_filtered_submittals;
            state.total = action.payload.total;
            state.inProcess = action.payload.in_process;
            state.confirmed = action.payload.confirmed;
        }).addCase(getSubmittalList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default submittalListSlice.reducer;
